import { useNavigate } from 'react-router-dom';
import { MouseEvent } from 'react';
import styles from './BreadcrumbItem.module.scss';

interface Props {
  children: string;
  href: string;
}

export function BreadcrumbItem(props: Props) {
  const navigate = useNavigate();

  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    navigate(props.href);
  };

  const className = [styles['breadcrumb-item']].filter(Boolean).join(' ');
  const anchorClassName = [styles['breadcrumb-item-anchor']]
    .filter(Boolean)
    .join(' ');

  return (
    <li className={className}>
      <a className={anchorClassName} href={props.href} onClick={onClick}>
        {props.children}
      </a>
    </li>
  );
}
